import { createApp } from 'vue';
import UserDashboard from 'JIX/components/user/dashboard/UserDashboard.vue';

const stash = window.Stash['frontpage'];

const dashboardApp = createApp(UserDashboard, stash.dashboard);
dashboardApp.mount('#user-dashboard-app');